import dayjs from 'dayjs';
import Language from 'ocus-shared-resources/src/Domains/Language/Language.ts';
import Member from 'ocus-shared-resources/src/Domains/Member/Member.ts';
import QueryBuilder
  from 'ocus-shared-resources/src/ModelBinding/QueryBuilder.ts';
import Cookies from 'js-cookie';
import LanguageCollection from 'ocus-shared-resources/src/Domains/Language/LanguageCollection.ts';

class LanguageService {
  constructor() {
    this.languages = new LanguageCollection();
    this.currentLanguage = Cookies.get('locale') || Cookies.get('i18next') || 'en';;
    this.currentLanguageInfo = {};

    this.waitFor(() => !!window.$nuxt?.$i18n?.i18next)
      .then(async () => {
        const i18next = window.$nuxt.$i18n.i18next;
        this.currentLanguage = window.$nuxt.$i18n.i18next.language;
        if ("") {
          await this.setAxiosInterceptor();
        }
        await this.loadLanguages();
        i18next.on('languageChanged', (lng) => this.changeLanguage(lng));
        this.changeLanguage(this.currentLanguage);
      });
  }

  async waitFor(test) {
    return new Promise(resolve => {
      const id = setInterval(() => {
          if (!test()) return;
          clearInterval(id);
          resolve();
        }, 100);
    });
  }

  async loadLanguages() {
    await this.waitFor(() => !! QueryBuilder.getAxios());
    this.languages = await Language.from([Member, '']).fetch();
  }

  async changeLanguage(lng, callback) {
    await this.waitFor(() => !!window.$nuxt?.$i18n?.i18next);
    const i18next = window.$nuxt.$i18n.i18next;
    await this.languageFinderIterator(lng, async (locale) => {
      const language = this.languages.find(({ code }) => code.replace(/_/g, '-') === locale);
      if (!language) return false;
      this.currentLanguage = language.code.replace(/_/g, '-');
      this.currentLanguageInfo = this.getLanguageInfo(this.currentLanguage);

      if (this.currentLanguage !== i18next.language) {
        i18next.changeLanguage(this.currentLanguage, async () => {
        Cookies.set('locale', this.currentLanguage);
          if (callback) {
            await callback(this.currentLanguage.replace(/-/g, '_'));
          }

          location.reload();
        });
      }
      return true;
    });
    const direction = this.currentLanguageInfo.direction || 'ltr';
    document.body.setAttribute('dir', direction);

    await this.languageFinderIterator(lng, async (locale) => {
      try {
        await import(`dayjs/locale/${locale.toLowerCase()}.js`);
        dayjs.locale(locale.toLowerCase());
        return true;
      } catch (e) {
        return false;
      }
    });
  }

  async languageFinderIterator(lng, callback) {
    if(!lng) return false;
    const localeParts = lng.replace(/[_-]/g, '_').split('_');
    const locales = [];
    while (localeParts.length > 0) {
      locales.push(localeParts.join('-'));
      localeParts.pop();
    }
    locales.push('en');
    while (locales.length > 0) {
      const locale = locales.shift();
      if (await callback(locale)) return;
    }
  }

  getLanguageInfo(lang) {
    const language = this.languages.find(({ code }) => code.replace(/_/g, '-') === lang);
    if (language) return language;
    if (lang !== 'en') return this.getLanguageInfo('en');
    return {};
  }

  async setAxiosInterceptor() {
    await this.waitFor(() => !!window?.$nuxt?.$axios);
    window.$nuxt.$axios.onRequest((config) => {
      config.headers['X-localization'] = this.currentLanguage;
    });
  }
}

// Inject plugin in instance
export default function LanguageServiceInit(context, inject) {
  inject('LanguageService', new LanguageService());
}
